import {useEffect, useState} from "react";

function mapStatistics (data) {
    let stockData = {};
  
    if (data !== null) { 
      console.log(data.stock_annual_stats); 

      stockData.MarketCap = data.stock_annual_stats[2].Value;
      stockData.EV = data.stock_annual_stats[3].Value;
      stockData.Revenue = data.stock_annual_stats[4].Value;
      stockData.OperatingIncome = data.stock_annual_stats[5].Value;
      stockData.NetIncome = data.stock_annual_stats[6].Value;
      stockData.EBITDA = data.stock_annual_stats[7].Value;
      stockData.EPS = data.stock_annual_stats[18].Value;

      if (data.stock_annual_stats[24]){
        stockData.PE = data.stock_annual_stats[24].Value;
      }else {
        stockData.PE = "N/A"
      }
      if (data.stock_annual_stats[25]){
        stockData.ForwardPE = data.stock_annual_stats[25].Value;
      }else {
        stockData.ForwardPE = "N/A";
      }
      if (data.stock_annual_stats[26]){
        stockData.PEG = data.stock_annual_stats[26].Value;
      }else {
        stockData.PEG = "N/A"
      }
      if (data.stock_annual_stats[10]){
        stockData.PB = data.stock_annual_stats[10].Value;
      }else {
        stockData.PB = "N/A"
      }
      if (data.stock_annual_stats[27]){
        stockData.PS = data.stock_annual_stats[27].Value;
      }else {
        stockData.PS = "N/A";
      }


      if (data.stock_annual_stats[30]){
        stockData.OperatingMargin = data.stock_annual_stats[30].Value;
      }else {
        stockData.OperatingMargin  = "N/A";
      }
      if (data.stock_annual_stats[31]){
        stockData.ProfitMargin = data.stock_annual_stats[31].Value;
      }else {
        stockData.ProfitMargin = "N/A";
      }
      if (data.stock_annual_stats[32]){
        stockData.EBITDAMargin = data.stock_annual_stats[32].Value;
      }else {
        stockData.EBITDAMargin = "N/A";
      }
      stockData.Equity= data.stock_annual_stats[16].Value;
      stockData.ReturnOnAssets = data.stock_annual_stats[34].Value;
      stockData.ReturnOnEquity = data.stock_annual_stats[35].Value;
      stockData.ReturnOnCapital = data.stock_annual_stats[36].Value;
      stockData.DividentYield = data.stock_annual_stats[20].Value;
      stockData.Debt = data.stock_annual_stats[13].Value;
      stockData.Assets = data.stock_annual_stats[11].Value;
      stockData.Liabilities = data.stock_annual_stats[12].Value;
      stockData.Cash = data.stock_annual_stats[14].Value;
      stockData.Interest = data.stock_annual_stats[10].Value;
      stockData.FXUSD = data.stock_annual_stats[0].Value;

      if (data.stock_annual_stats[37]){
        stockData.EV_EBITDA = data.stock_annual_stats[37].Value;
      }else {
        stockData.EV_EBITDA = "N/A";
      }

      if (data.stock_annual_stats[38]){
        stockData.EV_Revenue = data.stock_annual_stats[38].Value;
      }else {
        stockData.EV_Revenue = "N/A";
      }

      if (data.stock_annual_stats[21]){
        stockData.Price = data.stock_annual_stats[21].Value;
      }

      if (data.stock_annual_stats[22]){
        stockData.Price52WeekHigh = data.stock_annual_stats[22].Value;
      }
      
      if (data.stock_annual_stats[23]){
      stockData.Price52WeekLow = data.stock_annual_stats[23].Value;
      }
    }

    return stockData;
  }

function Statistics (props) {

const [statistics, setStatistics] = useState(null);

const ticker = props.ticker;

function fetchStats(url)  {
    
    const abortCtrl   = new AbortController();

    const fetchData= async () => {
          console.log("fetch stats... "); 
          try {
              const response = await fetch(url,{signal: abortCtrl.signal});
              const json = await response.json();
              setStatistics(mapStatistics(json));
              console.log("fetch stats done");  
          } catch (error) {
              if (error.name === 'AbortError'){
                  console.log("aborted", error);
              }
              else {
                  console.log("error", error);
              }
          }
    }
  
    fetchData();
  
    return () => abortCtrl.abort();
  }

  useEffect(() => {
    const server = "https://app.cuetraders.com";
    const url = server+"/api/get_annual_statistics.php?ticker="+ticker ;
    fetchStats(url);

  }, [ticker]);


  return (<div className="Statistics"> {statistics && <div>
    <div className="col-lg-4 col-sm-4 col-xs-8"> 
        <h4>Finaincials</h4>
        <table className="dataTable">
            <tbody className="tbody">
                <tr>
                <td><i className="tab-2-title">Market Cap.</i></td>
                <td><i className="tab-2-value">{statistics.MarketCap} </i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Enterprise Value</i></td>
                <td><i className="tab-2-value">{statistics.EV}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Revenue</i></td>
                <td><i className="tab-2-value">{statistics.Revenue}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Operating Income</i></td>
                <td><i className="tab-2-value">{statistics.OperatingIncome}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Net Income</i></td>
                <td><i className="tab-2-value">{statistics.NetIncome}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">EBITDA</i></td>
                <td><i className="tab-2-value">{statistics.EBITDA}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Operating Margin</i></td>
                <td><i className="tab-2-value">{statistics.OperatingMargin}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Profit Margin</i></td>
                <td><i className="tab-2-value">{statistics.ProfitMargin}</i></td>
                </tr>
            </tbody>
        </table>

        <h4>Balance Sheet</h4>
        <table className="dataTable">
            <tbody className="tbody">
                <tr>
                <td><i className="tab-2-title">Assets</i></td>
                <td><i className="tab-2-value">{statistics.Assets}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Liabilities</i></td>
                <td><i className="tab-2-value">{statistics.Liabilities}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Debt</i></td>
                <td><i className="tab-2-value">{statistics.Debt}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Cash</i></td>
                <td><i className="tab-2-value">{statistics.Cash}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Interest</i></td>
                <td><i className="tab-2-value">{statistics.Interest}</i></td>
                </tr>
                <tr>
                <td><i className="tab-2-title">Equity</i></td>
                <td><i className="tab-2-value">{statistics.Equity}</i></td>
                </tr>
            </tbody>
        </table>
    </div>
  
    <div className="col-lg-4 col-sm-4 col-xs-8"> 
    <h4>Ratios</h4>
    <table className="dataTable">
        <tbody className="tbody">
        <tr>
            <td><i className="tab-2-title">EPS</i></td>
            <td><i className="tab-2-value">{statistics.EPS}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">PE</i></td>
            <td><i className="tab-2-value">{statistics.PE}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">Forward PE</i></td>
            <td><i className="tab-2-value">{statistics.ForwardPE}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">PEG</i></td>
            <td><i className="tab-2-value">{statistics.PEG}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">PB</i></td>
            <td><i className="tab-2-value">{statistics.PB}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">PS</i></td>
            <td><i className="tab-2-value">{statistics.PS}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">EV/EBITDA</i></td>
            <td><i className="tab-2-value">{statistics.EV_EBITDA}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">EV/Revenue</i></td>
            <td><i className="tab-2-value">{statistics.EV_Revenue}</i></td>
        </tr>
    </tbody>
    </table>
    <h4>Return History</h4>
    <table className="dataTable">
        <tbody className="tbody">
            <tr>
                <td><i className="tab-2-title">52-Week High</i></td>
                <td><i className="tab-2-value">{statistics.Price52WeekHigh}</i></td>
            </tr>
            <tr>
            <td><i className="tab-2-title">52-Week Low</i></td>
                <td><i className="tab-2-value">{statistics.Price52WeekLow}</i></td>
            </tr>
            <tr>
            <td><i className="tab-2-title">Return on Equity</i></td>
                <td><i className="tab-2-value">{statistics.ReturnOnEquity}</i></td>
                </tr>
            <tr>
            <td><i className="tab-2-title">Return on Assets</i></td>
            <td><i className="tab-2-value">{statistics.ReturnOnAssets}</i></td>
            </tr>
        <tr>
            <td><i className="tab-2-title">Return on Capital</i></td>
            <td><i className="tab-2-value">{statistics.ReturnOnCapital}</i></td>
        </tr>
        <tr>
            <td><i className="tab-2-title">Divident Yield</i></td>
            <td><i className="tab-2-value">{statistics.DividentYield}</i></td>
        </tr>
        </tbody>
        </table>
    </div>
    </div>}
    </div>);
};

export default Statistics;
